<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Support Warranty Policy',
          to: {
            name: 'SupportWarrantyPolicy'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'SupportWarrantyPolicyEdit',
            params: {
              id: $route.params.id
            }
          }
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯Support Warranty Policy</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <SupportWarrantyPolicyCreateEdit></SupportWarrantyPolicyCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportWarrantyPolicyCreateEdit from '@/views/H-3__SupportWarrantyPolicy/c/SupportWarrantyPolicyCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    SupportWarrantyPolicyCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('supportWarrantyPolicy', ['policy']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getPolicy(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('supportWarrantyPolicy', {
      getPolicy: 'findById',
      savePolicy: 'save',
    }),
    cancelHandler() {
      this.$router.go(-1);
    },
    async saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.savePolicy(this.policy).then(() => {
          this.$router.push({ name: 'SupportWarrantyPolicy' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
